/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { format } from 'date-fns';
import { Typography, Grid, Box } from '@mui/material';
import SideBarInformationField from '../../../modules/shared/form/SideBarInformationField';
import AlarmMessagesGrid from './AlarmMessagesGrid';

// Runtime metric details component
interface RuntimeMetricDetailProps {
  runtimeMetric?: any;
}

const RuntimeMetricDetails: React.FunctionComponent<RuntimeMetricDetailProps> = (props) => {
  const { runtimeMetric } = props;
  const scrollRef = React.useRef<HTMLDivElement>(null);

  // Reset scroll position when a new runtime metric is selected
  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [runtimeMetric?.OrderName]);

  const formattedDate = (date) => {
    return date ? format(new Date(date), 'MM/dd/yyyy hh:mm aaa') : '';
  };

  const formattedNumber = (value, decimals = 2) => {
    return value ? Number(value).toFixed(decimals) : '-';
  };

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Typography variant="h2" component="h2" style={{ marginTop: '-12px' }}>
            {`Runtime Metrics: ${runtimeMetric?.OrderName || 'N/A'}`}
          </Typography>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SideBarInformationField label="Order Name:" value={runtimeMetric?.OrderName} />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField label="Variety:" value={runtimeMetric?.Variety} />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField label="Customer:" value={runtimeMetric?.Customer} />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField label="Operator:" value={runtimeMetric?.OperatorName} />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField
            label={`Start Time (${
              new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
            }):`}
            value={formattedDate(runtimeMetric?.OrderStartTime)}
          />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField
            label={`Complete Time (${
              new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
            }):`}
            value={formattedDate(runtimeMetric?.OrderCompleteTime)}
          />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField
            label="Seed Units (Actual):"
            value={formattedNumber(runtimeMetric?.SeedUnitsActual)}
          />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField
            label="Duration (Minutes):"
            value={runtimeMetric?.OrderDurationMinutes || '-'}
          />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField
            label="Treat Rate (units/min):"
            value={formattedNumber(runtimeMetric?.TreatRateUnitsPerMinute)}
          />
        </Grid>
        <Grid item xs={12}>
          <SideBarInformationField label="Fault Count:" value={runtimeMetric?.FaultCount || '0'} />
        </Grid>
      </Grid>
      <br />
      {(runtimeMetric?.AlarmMessages || runtimeMetric?.FaultMessages) && (
        <>
          <Typography variant="h3" component="h3" style={{ marginBottom: '10px' }}>
            Alarm Messages
          </Typography>
          <Box
            ref={scrollRef}
            sx={{
              maxHeight: '800px',
              overflowY: 'auto',
              paddingRight: '8px',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: '#555',
                },
              },
            }}
          >
            <AlarmMessagesGrid alarmMessages={runtimeMetric?.AlarmMessages || runtimeMetric?.FaultMessages} />
          </Box>
        </>
      )}
    </>
  );
};

export default RuntimeMetricDetails;
